document.addEventListener('DOMContentLoaded', () => {
  if (!window.location.pathname.includes('/cart')) return;

  const FREE_PRODUCT_VARIANT_ID = 42027606409293; // Replace with your free gift variant ID
  const MIN_PURCHASE_AMOUNT = 2500; // Minimum purchase amount in your store currency

  async function fetchCart() {
    const res = await fetch('/cart.js');
    return await res.json();
  }

  async function addFreeProduct() {
    return await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: FREE_PRODUCT_VARIANT_ID, quantity: 1 }] }),
    });
  }

  async function removeFreeProduct(line_item_key) {
    return await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line_item_key, quantity: 0 }),
    });
  }

  async function refreshCartDrawer() {
    // Shopify Dawn theme uses the cart drawer component
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.open === 'function') {
      await cartDrawer.open();  // Opens and refreshes the cart drawer UI
    } else {
      // Fallback to page reload if cart drawer doesn't exist
      location.reload();
    }
  }

  async function processCart() {
    const cart = await fetchCart();
    const subtotal = cart.items_subtotal_price / 100; // prices are in paise/cents
    let hasFreeProduct = false;
    let freeProductLine = null;

    for (const item of cart.items) {
      if (item.variant_id === FREE_PRODUCT_VARIANT_ID) {
        hasFreeProduct = true;
        freeProductLine = item.key;
        break;
      }
    }

    if (subtotal >= MIN_PURCHASE_AMOUNT && !hasFreeProduct) {
      await addFreeProduct();
      await refreshCartDrawer();
    } else if (subtotal < MIN_PURCHASE_AMOUNT && hasFreeProduct) {
      await removeFreeProduct(freeProductLine);
      await refreshCartDrawer();
    }
  }

  processCart();
});
